// Turns raw Firebase Auth errors (and native sign-in errors) into short,
// friendly messages, so users never see "Firebase: Error (auth/wrong-password)."
//
// Usage: setError(friendlyAuthError(error))
//   or:  setError(friendlyAuthError(error, "Couldn't sign in with Google."))

const MESSAGES = {
  "auth/invalid-email": "That email address doesn't look right.",
  "auth/missing-email": "Please enter your email address.",
  "auth/user-disabled": "This account has been disabled. Please contact support.",
  // Wrong email or password all map to one message (and it avoids revealing
  // whether an email is registered).
  "auth/user-not-found": "Incorrect email or password.",
  "auth/wrong-password": "Incorrect email or password.",
  "auth/invalid-credential": "Incorrect email or password.",
  "auth/invalid-login-credentials": "Incorrect email or password.",
  "auth/missing-password": "Please enter your password.",
  "auth/email-already-in-use":
    "An account already exists with that email. Try signing in instead.",
  "auth/weak-password":
    "Please choose a stronger password (at least 6 characters).",
  "auth/too-many-requests":
    "Too many attempts. Please wait a moment and try again.",
  "auth/network-request-failed":
    "Network error. Check your connection and try again.",
  "auth/popup-closed-by-user": "Sign-in was cancelled.",
  "auth/cancelled-popup-request": "Sign-in was cancelled.",
  "auth/popup-blocked":
    "Your browser blocked the sign-in window. Allow pop-ups and try again.",
  "auth/account-exists-with-different-credential":
    "You already have an account with this email using a different sign-in method.",
  "auth/requires-recent-login":
    "Please sign in again to complete this action.",
  "auth/operation-not-allowed": "This sign-in method isn't available right now.",
  "auth/expired-action-code": "That link has expired. Please request a new one.",
  "auth/invalid-action-code":
    "That link is invalid or has already been used.",
};

export function friendlyAuthError(
  error,
  fallback = "Something went wrong. Please try again.",
) {
  // Prefer the structured code; fall back to parsing it out of the message
  // (e.g. "Firebase: Error (auth/invalid-credential).").
  let code = error?.code || "";
  if (!code && error?.message) {
    const match = error.message.match(/auth\/[a-z-]+/);
    if (match) code = match[0];
  }
  if (MESSAGES[code]) return MESSAGES[code];

  // Native Google/Apple sign-in errors don't use auth/ codes.
  const msg = (error?.message || "").toLowerCase();
  if (msg.includes("cancel") || msg.includes("canceled")) {
    return "Sign-in was cancelled.";
  }
  if (msg.includes("network") || msg.includes("timeout")) {
    return "Network error. Check your connection and try again.";
  }
  return fallback;
}
